














import {
  computed,
  defineComponent,
  PropType,
} from '@vue/composition-api';
import { Location } from '@/models';

export default defineComponent({
  name: 'location-check-button',
  props: {
    label: {
      type: String,
      required: true,
    },
    // 位置情報の取得前は null。required: true だと null を渡したときに Vue 2 の型チェックで警告が出るため optional にしている
    currentLocation: {
      type: Object as PropType<Location | null>,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    unavailableLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const hasLocation = computed<boolean>(() => !!props.currentLocation);

    const onClick = (): void => {
      if (!hasLocation.value) return;

      emit('click');
    };
    return {
      hasLocation,
      onClick,
    };
  },
});
